// extracted by mini-css-extract-plugin
export var subtitleBackground = "styles-module--subtitle-background--Xv0HZ";
export var subtitleBorder = "styles-module--subtitle-border--4R+G3";